(function(){
  var COLORS={'onyx':'#1a1a1a','vintage onyx':'#2b2b2b','vintage black':'#222','black':'#111','white':'#f4f4f1','ivory':'#efe9dd','dove':'#cfcabd','sage':'#9aa388','olive':'#5f6347','graphite':'#3c3c3a','oatmeal':'#d9cdb6','sand':'#cdbb98','brown':'#6b4f3a','blush':'#dcbcb4','hot milk':'#d9c6a8','woodland':'#5a5a43'};
  function money(c){return '$'+(c/100).toFixed(2);}
  function init(root){
    var variants=JSON.parse(root.querySelector('[data-cbg-variants]').textContent);
    var idInput=root.querySelector('[data-cbg-variant-id]');
    var priceEl=root.querySelector('[data-cbg-price]');
    var compareEl=root.querySelector('[data-cbg-compare]');
    var colorLabel=root.querySelector('[data-cbg-color-label]');
    var cells=root.querySelectorAll('.cbg-pdp__cell');
    function setAtcText(t){root.querySelectorAll('[data-cbg-atc-text]').forEach(function(el){el.textContent=t;});}
    function setAtcDisabled(b){root.querySelectorAll('[data-cbg-atc]').forEach(function(el){el.disabled=b;});}
    root.querySelectorAll('.cbg-pdp__swatch-dot').forEach(function(d){
      var n=(d.getAttribute('data-color-name')||'').trim();
      d.style.background=COLORS[n]||'#bbb';
    });
    function currentSelection(){
      var sel=[];
      root.querySelectorAll('[data-cbg-option]').forEach(function(g){
        var pos=parseInt(g.getAttribute('data-option-position'),10);
        var a=g.querySelector('.is-selected');
        sel[pos]=a?a.getAttribute('data-cbg-value'):null;
      });
      return sel;
    }
    function findVariant(sel){
      return variants.find(function(v){
        for(var i=0;i<sel.length;i++){
          if(sel[i]==null)continue;
          var ov=i===0?v.option1:(i===1?v.option2:v.option3);
          if(ov!==sel[i])return false;
        }
        return true;
      });
    }
    function currentColor(){
      var g=root.querySelector('.cbg-pdp__opt--color');
      if(!g)return null;
      var a=g.querySelector('.is-selected');
      return a?a.getAttribute('data-cbg-value'):null;
    }
    function filterByColor(color){
      if(!color)return;
      var c=color.toLowerCase(),any=false;
      cells.forEach(function(cell){
        var mc=(cell.getAttribute('data-color')||'').toLowerCase();
        var show=(mc===c);
        cell.style.display=show?'':'none';
        if(show)any=true;
      });
      if(!any){cells.forEach(function(cell){cell.style.display='';});}
    }
    function update(){
      var v=findVariant(currentSelection());
      if(!v){setAtcDisabled(true);setAtcText('Unavailable');return;}
      idInput.value=v.id;
      priceEl.textContent=money(v.price);
      if(compareEl){
        if(v.compare_at_price&&v.compare_at_price>v.price){compareEl.textContent=money(v.compare_at_price);compareEl.hidden=false;}
        else{compareEl.hidden=true;}
      }
      setAtcDisabled(!v.available);
      setAtcText(v.available?('Add to cart • '+money(v.price)):'Sold out');
    }
    function doAdd(){
      var v=findVariant(currentSelection());
      if(!v||!v.available)return;
      idInput.value=v.id;
      var prev='Add to cart • '+money(v.price);
      setAtcDisabled(true);setAtcText('Adding…');
      function done(){setAtcText(prev);setAtcDisabled(false);}
      if(window.cbgCart){
        window.cbgCart.add(idInput.value,1).then(function(){done();}).catch(function(){done();});
      }else{
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(idInput.value,10),quantity:1}]})})
          .then(function(r){return r.json();})
          .then(function(){window.location.href='/cart';})
          .catch(function(){done();});
      }
    }
    root.querySelectorAll('.cbg-pdp__swatch, .cbg-pdp__size').forEach(function(btn){
      btn.addEventListener('click',function(){
        var g=this.closest('[data-cbg-option]');
        g.querySelectorAll('[data-cbg-value]').forEach(function(b){b.classList.remove('is-selected');});
        this.classList.add('is-selected');
        if(g.classList.contains('cbg-pdp__opt--color')){
          if(colorLabel){colorLabel.textContent=this.getAttribute('data-cbg-value');}
          filterByColor(this.getAttribute('data-cbg-value'));
        }
        update();
      });
    });
    document.addEventListener('click',function(e){
      var btn=e.target.closest?e.target.closest('[data-cbg-atc]'):null;
      if(!btn||!root.contains(btn))return;
      e.preventDefault();
      e.stopImmediatePropagation();
      doAdd();
    },true);
    var form=root.querySelector('.cbg-pdp__form');
    if(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        doAdd();
      });
    }
    update();
    filterByColor(currentColor());
  }
  function boot(){document.querySelectorAll('[data-cbg-pdp]').forEach(init);}
  if(document.readyState!=='loading'){boot();}else{document.addEventListener('DOMContentLoaded',boot);}
})();
